<a
	*ngIf="!isR103"
	class="c-menu__link"
	[ngClass]="{ inactive: isDisabled, active: !isDisabled, enabledLink: isActive }"
	(click)="allow ? navigate() : (allow = false)"
>
	<span class="c-menu__text" [ngClass]="{ inactive: isDisabled, active: !isDisabled }" style="font-size: 1.3em">
		<div [ngClass]="{ 'menu_active_item primary-color': isActive }">
			<div>
				{{ sectiontitle }}
			</div>
		</div>
	</span>
</a>
<div *ngIf="isR103">
	<div
		class="c-menu__link {{ sectiontitle }}"
		[ngClass]="{ inactive: isDisabled, active: !isDisabled, enabledLink: isActive }"
		(click)="allow ? navigate() : (allow = false)"
	>
		<span class="c-menu__text" [ngClass]="{ inactive: isDisabled, active: !isDisabled }" style="font-size: 1.3em">
			<div [ngClass]="{ 'menu_active_item primary-color': isActive }">
				<div>
					{{ sectiontitle }}
				</div>
			</div>
		</span>
		<app-printable-report-item-r1 *ngIf="isActive && !isDisabled"></app-printable-report-item-r1>
		<app-product-csv-downnload-r6 [key]="sectiontitle" *ngIf="isActive && !isDisabled"></app-product-csv-downnload-r6>
	</div>
</div>
